export default __webpack_public_path__ + "static/media/HometutorBG2.9793dd1f.png";